import * as $runtime from "../runtime.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dOrdering from "../Data.Ordering/index.js";
import * as Data$dShow from "../Data.Show/index.js";
const $StepValue = (tag, _1) => ({tag, _1});
const Any = /* #__PURE__ */ $StepValue("Any");
const Step = value0 => $StepValue("Step", value0);
const renderStepValue = v => {
  if (v.tag === "Any") { return "any"; }
  if (v.tag === "Step") { return Data$dShow.showNumberImpl(v._1); }
  $runtime.fail();
};
const eqStepValue = {
  eq: x => y => {
    if (x.tag === "Any") { return y.tag === "Any"; }
    return x.tag === "Step" && y.tag === "Step" && x._1 === y._1;
  }
};
const ordStepValue = {
  compare: x => y => {
    if (x.tag === "Any") {
      if (y.tag === "Any") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "Any") { return Data$dOrdering.GT; }
    if (x.tag === "Step" && y.tag === "Step") { return Data$dOrd.ordNumber.compare(x._1)(y._1); }
    $runtime.fail();
  },
  Eq0: () => eqStepValue
};
export {$StepValue, Any, Step, eqStepValue, ordStepValue, renderStepValue};
